import React from 'react';
import { StyledContainer } from './styles';
import useRouter from '../../../../hooks/common/useRouter';
import { LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import { SETTLEMENT_BY_BRAND_FORM_INIT_STATE } from '../../constants';
import { isSettlementByBrandForm } from '../../utils/guards';
import { OnChangeFn, PaginationState } from '@tanstack/react-table';
import SettlementListSearchBoxByBrand from '../SettlementListSearchBoxByBrand';
import { convertSettlementByBrandFormToParams } from '../../utils';
import SettlementListByBrand from '../SettlementListByBrand/SettlementListByBrand';

const INITIAL_PAGE = LIST_PAGINATION_MODEL.pageNum + 1;
const INITIAL_PAGE_SIZE = LIST_PAGINATION_MODEL.pageSize;

const SettlementListByBrandWrap = (): JSX.Element => {
  const router = useRouter();
  const { query, pathname } = router;

  const page = query.page ? Number(query.page) : INITIAL_PAGE;
  const pageSize = query.pageSize ? Number(query.pageSize) : INITIAL_PAGE_SIZE;

  const params = isSettlementByBrandForm(query) ? query : SETTLEMENT_BY_BRAND_FORM_INIT_STATE;

  const pagination = {
    pageIndex: page - 1,
    pageSize: pageSize,
  };

  const request = convertSettlementByBrandFormToParams({
    form: params,
    pagination,
  });

  const handlePagination: OnChangeFn<PaginationState> = (updaterOrValue) => {
    const newPagination = typeof updaterOrValue === 'function' ? updaterOrValue(pagination) : updaterOrValue;

    router.push(pathname, {
      query: {
        ...router.query,
        page: String(newPagination.pageIndex + 1),
        pageSize: String(newPagination.pageSize),
      },
    });
  };

  return (
    <StyledContainer>
      <SettlementListSearchBoxByBrand />
      <SettlementListByBrand request={request} paginationState={[pagination, handlePagination]} />
    </StyledContainer>
  );
};

export default SettlementListByBrandWrap;
